<template>
  <div class="page modal-page-scroll d-flex flex-column">
    <div class="row header-page">
      <div class="col-12 mb-4">
        <h3>
          I 5 portafogli di investimento sostenibile
        </h3>
      </div>
      <div class="col-12">
        <b-tabs pills class="list-tabs w-100">
          <b-tabs pills class="list-tabs" v-if="areaList.length > 0">
            <b-tab :title="item.title" v-for="item in areaList" :key="item.id">
              <b-card-text>
                <div class="row">
                  <div class="col-12 position-absolute">
                    <div
                      class="svg-banner-area w-100 h-100 d-flex align-items-center"
                      v-bind:class="getBannerClasses(item.svgClass)"
                    >
                      <!--                      <inline-svg-->
                      <!--                        :src="window.width<=1440 ? require('../../assets/images/banner/03-main.svg') : require('../../assets/images/banner/03-wide.svg')"-->
                      <!--                        width="100%"-->
                      <!--                        :height="window.width<=1440 ? '200px' : '350px'"-->
                      <!--                        fill="black"-->
                      <!--                        aria-label="HOME"-->
                      <!--                      ></inline-svg>-->
                      <svg-viewer
                        :src="
                          window.width <= 1440
                            ? require('../../assets/images/banner/03-main.svg')
                            : require('../../assets/images/banner/03-wide.svg')
                        "
                        width="100%"
                        :height="window.width <= 1440 ? '200px' : '350px'"
                      ></svg-viewer>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-7">
                    <h3 class="mb-3">{{ item.title }}</h3>
                    <div class="mb-3 area-info-desc">
                      {{ item.desc }}
                    </div>
                    <div class="mb-3 area-info-consequences">
                      <div class="minor-title mb-2">Quali conseguenze</div>
                      {{ item.consequences }}
                    </div>
                  </div>
                  <div class="col-5"></div>
                </div>
                <div class="row">
                  <div class="col-12">
                    <div class="minor-title mb-2">
                      Obiettivi per lo sviluppo sostenibile
                    </div>
                    <div class="row">
                      <div class="col-6" v-for="sdg in item.sdg" :key="sdg.id">
                        <sdg-panel
                          :title="sdg.name"
                          :text="sdg.desc"
                          :icon="sdg.icon"
                        ></sdg-panel>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12">
                    <div class="minor-title mb-2">Contributi</div>
                    <div class="d-flex flex-row">
                      <contrib-panel
                        class="flex-fill"
                        :title="contrib.title"
                        :text="contrib.placeholder"
                        :icon="contrib.icon"
                        v-for="contrib in item.contribs"
                        :key="contrib.id"
                      ></contrib-panel>
                    </div>
                  </div>
                </div>
              </b-card-text>
            </b-tab>
          </b-tabs>
        </b-tabs>
      </div>
    </div>
  </div>
</template>

<script>
import SdgPanel from "../../components/SdgPanel";
import ContribPanel from "../../components/ContribPanel";
export default {
  name: "AreasInfo",
  components: { ContribPanel, SdgPanel },
  props: {
    areaId: Number,
    areaList: Array
  },
  data: () => {
    return {
      // areaList: [],
      window: {
        width: 0,
        height: 0
      }
    };
  },
  created() {
    // this.areaList = JSON.parse(JSON.stringify(getAreaListData(this.$store.state.areaValue)));
  },
  mounted() {
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
  },
  methods: {
    handleResize() {
      this.window.width = window.innerWidth;
      this.window.height = window.innerHeight;
    },
    getBannerClasses(cssClass) {
      const result = [];
      let className = "";

      // const selected = this.areaList.filter(a => a.selected).sort((a, b) => a.id<b.id ? -1 : a.id>b.id ? 1 : 0);
      className = `svg-area-${cssClass}`;

      result.push(className);
      return result;
    }
  }
};
</script>

<style scoped></style>
